module.exports = __webpack_public_path__ + "static/img/h18.263b6c1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rural/tour1/h18.jpg
// module id = +GwQ
// module chunks = 0